import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router";
import Layout from "./Layout";
import Loading from "@components/Statuses/Loading";
import Fail from "@components/Statuses/Fail";
import Button from "@components/Button";

const NotFound = lazy(() => import("@pages/NotFound"));
const HomePage = lazy(() => import("@pages/HomePage"));
const AboutPage = lazy(() => import("@pages/AboutPage"));
const CaseStudyPage = lazy(() => import("@pages/CaseStudyPage"));
const CaseStudyDetailPage = lazy(() => import("@pages/CaseStudyDetailPage"));
const ContactPage = lazy(() => import("@pages/ContactPage"));

function Router() {
    class ErrorBoundary extends React.Component {
        constructor(props) {
          super(props);
          this.state = { hasError: false, error: "", errorInfo: "" };
        }
      
        static getDerivedStateFromError() {
          return { hasError: true };
        }
      
        componentDidCatch(error, errorInfo) {
          this.setState({ error: error, errorInfo: errorInfo })
        }
      
        render() {
          if (this.state.hasError) {
            return <div className="error-boundary">
                <Fail>
                  <h2>Coś poszło nie tak.</h2>
                  <p dangerouslySetInnerHTML={{ __html: (this.state.error) }}></p>
                  {/* <p dangerouslySetInnerHTML={{ __html: (this.state.errorInfo?.componentStack)?.replaceAll("\n", "<br/>") }}></p> */}
                  <p><strong>Ścieżka:</strong> {document.location.href}</p>
                  <p><strong>UserAgent:</strong> {navigator.userAgent}</p>
                  <Button action={() => { location.reload() }}>Odśwież stronę</Button>
                </Fail>
            </div>
          }
      
          return this.props.children; 
        }
    }

    return (
        <ErrorBoundary>
          <Suspense fallback={<Loading fullScreen>
            <p>Proszę czekać...</p>
          </Loading>}>
            <Routes>
                <Route element={<Layout/>}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/o-nas" element={<AboutPage />} />
                    <Route path="/case-study" element={<CaseStudyPage />} />
                    <Route path="/case-study/:slug" element={<CaseStudyDetailPage />} />
                    <Route path="/kontakt" element={<ContactPage />} />
                    <Route path="*" element={<NotFound/>}/>
                </Route>
            </Routes>
          </Suspense>
        </ErrorBoundary>
    )
}

export default Router
